import { useState, useEffect } from "react";
import { Phone, Menu, X } from "lucide-react";

const NAV = [
  { label: "Services", href: "#services" },
  { label: "Pricing", href: "#pricing" },
  { label: "Service Area", href: "#area" },
  { label: "Contact", href: "#enquiry" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 w-full transition-all ${
        scrolled ? "bg-white/95 backdrop-blur-md border-b border-slate-200 shadow-sm" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="flex h-28 sm:h-32 lg:h-36 items-center justify-between">
          <a href="#top" data-testid="logo-link" className="flex items-center group">
            <img
              src="/brand/daztec-logo.png"
              alt="DazTec — friendly local tech support"
              className="h-24 sm:h-28 lg:h-32 w-auto object-contain group-hover:scale-[1.03] transition-transform"
            />
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="text-base font-medium text-slate-700 hover:text-[#1E56B8] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-3">
            <a
              href="tel:0409049094"
              data-testid="header-call-button"
              className="hidden sm:inline-flex items-center gap-2 h-12 px-5 rounded-xl bg-[#1E56B8] hover:bg-[#2E6BD9] text-white font-semibold shadow-md hover:-translate-y-0.5 transition-all"
            >
              <Phone className="w-5 h-5" strokeWidth={2.25} />
              <span>0409 049 094</span>
            </a>

            <button
              onClick={() => setOpen((v) => !v)}
              className="md:hidden h-12 w-12 inline-flex items-center justify-center rounded-xl border border-slate-300 bg-white"
              data-testid="mobile-menu-toggle"
              aria-label="Open menu"
            >
              {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>
        </div>

        {open && (
          <div className="md:hidden pb-6 pt-2" data-testid="mobile-menu">
            <div className="flex flex-col gap-2">
              {NAV.map((item) => (
                <a
                  key={item.href}
                  href={item.href}
                  onClick={() => setOpen(false)}
                  className="px-4 py-3 rounded-lg text-lg font-medium text-slate-800 hover:bg-slate-100"
                  data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                >
                  {item.label}
                </a>
              ))}
              <a
                href="tel:0409049094"
                data-testid="mobile-call-button"
                className="mt-2 inline-flex items-center justify-center gap-2 h-14 rounded-xl bg-[#1E56B8] text-white font-semibold text-lg"
              >
                <Phone className="w-5 h-5" />
                Call 0409 049 094
              </a>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}
